import { Injectable } from '@angular/core';
import { EstablishmentIsOpenService } from '../../../../../core/service/estasblishment-is-open.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../../environments/environment';
import { Observable, shareReplay } from 'rxjs';
import { InfoEstablishment } from '../interface/info-banner.interface';

@Injectable({
  providedIn: 'root'
})
export class InfoBannerService {
  private api = environment.apiUrl;
  constructor(private http: HttpClient,
    private establishmentIsOpenService: EstablishmentIsOpenService,
  ) { }


  getInfoEstablishment(id: string): Observable<InfoEstablishment> {
    // console.log('URL del API:', `${this.api}/getLink/${id}`); // Para debug
    return this.http.get<InfoEstablishment>(`${this.api}/getLink/${id}`).pipe(
      shareReplay(1)
    );
  }

  isEstablishmentOpen(apertura: string, cierre: string, isOpen: boolean): boolean {
    return this.establishmentIsOpenService.isEstablishmentOpen(apertura, cierre, isOpen);
  }

}
